var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { useMedia } from 'react-media-match';
import styled, { ThemeProvider } from 'styled-components';
import gridTheme from './theme';
export var browserSupportsGrid = function () {
    var supported = true;
    if (typeof window !== 'undefined') {
        try {
            if (!CSS.supports('display', 'grid')) {
                throw new Error();
            }
        }
        catch (e) {
            supported = false;
        }
    }
    return supported;
};
var StyledGrid = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-gap: ", ";\n  max-width: ", ";\n"], ["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-gap: ", ";\n  max-width: ", ";\n"])), function (_a) {
    var fractions = _a.fractions, _b = _a.columns, columns = _b === void 0 ? 1 : _b;
    return fractions || "repeat(" + columns + ", 1fr)";
}, function (_a) {
    var _b = _a.colGap, colGap = _b === void 0 ? 0 : _b, _c = _a.rowGap, rowGap = _c === void 0 ? 0 : _c;
    return rowGap + " " + colGap;
}, function (_a) {
    var component = _a.theme.component;
    return component.grid.maxWidth;
});
var FlexFallback = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  ",
    "\n"])), function (_a) {
    var columns = _a.columns, rowGap = _a.rowGap, colGap = _a.colGap;
    return columns &&
        "\n    > * {\n      flex: 1 1 " + 100 / columns + "%;\n      \n      " + (colGap
            ? "max-width: calc(" + 100 / columns + "% - " + colGap + "); \n             margin-right: " + colGap + ";\n            "
            : '') + "\n\n      " + (rowGap
            ? "\n            &:not(:nth-last-child(-n + " + columns + ")) {\n            margin-bottom: " + rowGap + ";\n            }\n            "
            : '') + "\n    }\n  ";
});
export var Grid = function (_a) {
    var fractionsPerRow = _a.fractionsPerRow, cellsPerRow = _a.cellsPerRow, className = _a.className, columns = _a.columns, theme = _a.theme, useFallback = _a.useFallback, props = __rest(_a, ["fractionsPerRow", "cellsPerRow", "className", "columns", "theme", "useFallback"]);
    var _b = useState(true), gridSupported = _b[0], setGridSupported = _b[1];
    // Setting default to true, causes stories crashing with error
    // str.replace is not a function
    // while trying to parse the props if there is a "<!-- PROPS -->" area in the readme
    var reallyUseFallback = useFallback === undefined ? true : useFallback;
    useEffect(function () {
        if (!browserSupportsGrid() && reallyUseFallback) {
            setGridSupported(false);
        }
    }, [reallyUseFallback]);
    var fragctionCellsPerRow;
    // initialize variables and assign them conditionally because useMedia Hook can't be called conditionally
    var fractionsMobile = [];
    var fractionsTablet = [];
    var fractionsDesktop = [];
    if (fractionsPerRow) {
        fragctionCellsPerRow = [
            fractionsPerRow.mobile.length,
            fractionsPerRow.tablet.length,
            fractionsPerRow.desktop.length,
        ];
        (fractionsMobile = fractionsPerRow.mobile, fractionsTablet = fractionsPerRow.tablet, fractionsDesktop = fractionsPerRow.desktop);
    }
    var fractions = useMedia({
        mobile: fractionsMobile.join(' '),
        tablet: fractionsTablet.join(' '),
        desktop: fractionsDesktop.join(' '),
    });
    var _c = fragctionCellsPerRow || cellsPerRow || (columns ? [columns, columns, columns] : [1, 1, 1]), mobile = _c[0], tablet = _c[1], desktop = _c[2];
    var renderedColumns = useMedia({
        mobile: mobile,
        tablet: tablet || mobile,
        desktop: desktop || mobile,
    });
    return (React.createElement(ThemeProvider, { theme: gridTheme }, gridSupported ? (React.createElement(StyledGrid, __assign({ className: className, columns: renderedColumns, fractions: fractions }, props))) : (React.createElement(FlexFallback
    // Add Class so you can override style with Class
    , __assign({ 
        // Add Class so you can override style with Class
        className: className + " noGridSupport", columns: renderedColumns }, props)))));
};
export var Cell = function (_a) {
    var children = _a.children;
    return React.createElement("div", null, children);
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map